/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutDeliveryPointController', function ($scope, $q, $element, ControlService) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'DeliveryPoint';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;

            $scope.Control.Selected = 1; 

            var savedDeliveryPointId;

            $scope.Control.setSelectedDeliveryPoint = function (value) {

                if (savedDeliveryPointId == value.Id)
                    return;

                var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingmethod').scope(), shMethodId;

                $scope.Model.Data.DeliveryPoints.forEach(function (th) {
                    if (th.Id == value.Id) {
                        $scope.Control.Selected = th;
                        $scope.Order.Current.DeliveryPoint = th;
                        $scope.DeliveryPoint.Current = th;

                        if (!shScope.Control.Loading && (!$scope.$parent.ShippingMethod.Current || !$scope.$parent.ShippingMethod.Current.Method || th.ShippingMethods.indexOf($scope.$parent.ShippingMethod.Current.Method.Id) < 0)) {                      
                            if (checkoutOverrides && checkoutOverrides.DeliveryPoint && typeof checkoutOverrides.DeliveryPoint.TransformData === 'function') {
                                checkoutOverrides.DeliveryPoint.TransformData(th, shScope);
                            } else {
                                if ($scope.Control.Selected.Code === "fromStore") {
                                    //if there is selected store
                                    if ($scope['Order'].Current.Store.Id != 0) {
                                        var storeId = $scope['Order'].Current.Store.Id;
                                        //find shipping method id
                                        _.each(shScope.Model.Data.Methods, function (method) {
                                            _.each(method.Options, function (option) {
                                                if (option.StoreId == storeId) shMethodId = method.Id;
                                            });
                                        });
                                    } else {
                                        //find first available shipping method id
                                        var methodIds = _.pluck(shScope.Model.Data.Methods, 'Id');
                                        shMethodId = _.first(_.intersection(methodIds, th.ShippingMethods));
                                    }
                                } else {
                                    //find first available shipping method id
                                    var methodIds = _.pluck(shScope.Model.Data.Methods, 'Id');
                                    shMethodId = _.first(_.intersection(methodIds, th.ShippingMethods));
                                }
                            }   
                        }
                    }
                });

                ControlService.invokeCheckout($scope, $element, 'SetDeliveryPoint', value).then(function (setResponse) {
                    $scope.setControlValue(controlName, $scope.Control.Selected);
                    //set selected shipping method
                    shScope.Control.setSelectedMethod(shMethodId);

                    savedDeliveryPointId = $scope.Control.Selected.Id;

                    if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                        $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                            var stScope = angular.element('.x-control.x-angular-control.x-checkoutstore').scope();
                            if ($scope.Control.Selected.Code == 'fromStore' && stScope.Control.Selected > 0 && stScope.Control.Map == false)
                                stScope.Control.SetMap();

                            var checkoutScope = angular.element('.checkout-region').scope();
                            var biScope = angular.element('.x-control.x-angular-control.x-checkoutbillingaddress').scope();
                            var defaultBilllingAddress = _.first(_.filter(biScope.Model.Data.Addresses, function (x) { return x.IsDefault == true; }));

                            if ($scope.Control.Selected.Code == 'fromStore') {

                                biScope.Control.getPrefectures();
                                biScope.Control.getCities();
                                biScope.Control.getAreas();

                                if (defaultBilllingAddress) {
                                    biScope.Control.Selected = defaultBilllingAddress.Id;
                                    biScope.Control.setAddress(defaultBilllingAddress);
                                } else {
                                    $scope.Control.Form = {};
                                }
                            } else {
                                if (checkoutScope.BillingAsShipping)
                                    biScope.Control.Selected = 0;
                                    biScope.Control.setAddress($scope['Order'].Current.Shipping);
                            }
                        }, function (orderError) {
                            throw orderError;
                        });
                    }

                    if ($scope.Config.IsTimeslotEnabled)
                        $('.x-control.x-angular-control.x-checkoutordertimeslot').get(0).reload();

                    if ($scope.Config.IsExplicitTimeslotEnabled)
                        $('.x-control.x-angular-control.x-checkoutorderexplicittimeslot').get(0).reload();

                    $scope.Control.Loading = false;

                }, function (setError) {
                    throw setError;
                });
            };

            $scope.Control.IsPointAvailable = function (option) {
                if (checkoutOverrides && checkoutOverrides.DeliveryPoint && typeof checkoutOverrides.DeliveryPoint.IsPointAvailable === 'function') {
                    return checkoutOverrides.DeliveryPoint.IsPointAvailable(option);
                }
                return false;
            };

            var applyModel = function () {

                var selectedDeliveryPoint;
                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.DeliveryPoint)
                    selectedDeliveryPoint = $scope['Order'].Current.DeliveryPoint;

                if (selectedDeliveryPoint == undefined)
                    selectedDeliveryPoint = _.first($scope.Model.Data.DeliveryPoints);

                var deliveryPoint = _.first(_.filter($scope.Model.Data.DeliveryPoints, function (x) { return x.Id === selectedDeliveryPoint.Id && $scope.Control.IsPointAvailable(x); }));
                if (!deliveryPoint) {
                    deliveryPoint = _.first($scope.Model.Data.DeliveryPoints);
                    $scope.Control.setSelectedDeliveryPoint(deliveryPoint);
                }

                $scope.Control.Selected = deliveryPoint;
                $scope.setControlValue(controlName, $scope.Control.Selected);

                savedDeliveryPointId = deliveryPoint.Id;
            };

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;

                if (!$scope.Config.IsShippingEnabled && $scope.Config.IsStorePickupEnabled) {
                    var valid = $scope.Control.Selected === 1 || $scope.Control.Selected === 2;
                    $scope.Control.IsValid = valid;
                }

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }
            };

            setTimeout(function () {

                var orderScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                orderScope.$watch('Model.Data.Products', function (newProductsArray, prevProductsArray) {

                    if (!newProductsArray && !prevProductsArray)
                        return;

                    if (!Array.isArray(newProductsArray) && !Array.isArray(prevProductsArray))
                        return;

                    if (prevProductsArray.length === newProductsArray.length)
                        return;

                    $element.get(0).reload();
                });

            }, 300);

            $element.get(0).reload = function () {
                var deferred = $q.defer();

                ControlService.getCheckoutData("GetDeliveryPointData", $scope, $element).then(function (response) {
                    $scope.Model = {};
                    angular.extend($scope.Model, response);
                    applyModel();
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            ControlService.getCheckoutData("GetDeliveryPointData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                applyModel();
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        });
})();
